import { Document } from "../../models";
import { UserToken } from "../../types/token/token";

interface LogClickResponse {
    key: string
    status: 'Ok' | string
}

export default class CollaborationService {
    #token: UserToken = null
    #url: string = ''
    constructor(token: UserToken) {
        this.#token = token;
    }

    getHeaders() {
        return {
            'Authorization': 'Bearer ' + this.#token
        };
    }

    postHeaders() {
        return {
            'Authorization': 'Bearer ' + this.#token,
            'Content-Type': 'application/json'
        };
    }

    setToken = (token: UserToken, url?: string) => {
        this.#token = token;
        this.#url = url ?? '';
    }

    getToken() {
        return this.#token;
    }

    async logClick(docId: string) {
        try {
            if(!docId) return { val: false, isAborted: false }
            const address = `${this.#url}/click?docId=${docId}`

            const res = await fetch(address, {
                method: 'GET',
                headers: this.getHeaders(),
            })
               
            const result: LogClickResponse = await res.json()
            if(result.status !== 'Ok') return { val: false, isAborted: false }
            
            return { val: true, isAborted: false }
        }
        catch(err) {
            //@ts-ignore
            if (err.name === 'AbortError') {
                return { val: false, isAborted: true }
            }
            
            return { val: false, isAborted: false }
        }

    }
}

